<template>
  <div class='vipFans'>
    <div class="m750">
      <publicHeader :pageTitle="pageTitle" v-if="!noHeader"></publicHeader>
      <div class="zhanwei" v-if="!noHeader">

    </div>
      <div class="top">
        <div class="top_main">
          <p class="tips">ROCKET FANS CARD</p>
          <p class="times" v-if="time==0">购买火星卡享受更多服务</p>
          <p class="times" v-else>到期时间：<span>{{year}}</span> 年 {{month}} 月 {{day}} 日</p>
        </div>
      </div>
      <div class="sort1">
        <div class="title">
          <span class="title_left"></span>
          <h3>尊享套餐</h3>
          <!-- <img src="../assets/images/title1.png" class="title_img" alt=""> -->
          <span class="title_right"></span>
        </div>
        <div class="sort1_main">
          <div class="goods" v-for="(item,index) in goodslist" :key="index">
            <a @click="handleClick(item.url)">
              <div class="goods_img">
                <img class="img" :src="item.img" alt />
              </div>
              <div class="goods_news">
                <div class="price">
                  <span>￥</span>
                  <span class="money">{{item.price}}</span>
                </div>
                <div class="buy">立即购买</div>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div class="sort2">
        <div class="title">
          <span class="title_left"></span>
          <h3>尊享权益</h3>
          <span class="title_right"></span>
        </div>
        <div class="sort2_main">
          <Power :powerList='powerList'></Power>
        </div>
      </div>
      <div class="sort3">
        <div class="title">
          <span class="title_left"></span>
          <h3>专属赠送</h3>
          <span class="title_right"></span>
        </div>
        <div class="sort3_main">
          <img class="crown" src="https://images.zhibo.tv/2020/0723/crown.png" />
          <p>赠在线观看台球会员赛事直播、点播权益</p>
        </div>
      </div>
      <div class="sort4">
        <div class="title">
          <span class="title_left"></span>
          <h3>活动说明</h3>
          <span class="title_right"></span>
        </div>
        <div class="sort4_main">
          <p v-html="desc"></p>
        </div>
      </div>
      <div class="bottom">
        活动最终解释权归中国体育所有
      </div>
    </div>
  </div>
</template>

<script>
import publicHeader from '../components/PublicHeader'
import Power from '../components/Power'

export default {
  components: { Power, publicHeader },
  data () {
    return {
      pageTitle: '奥沙利文火星卡',
      token: '',
      statistics: '',
      isShare: '',
      time: 0,//时间
      year: 0,
      month: 0,
      day: 0,
      desc: '',
      goodslist: [],
      pt: '',
      pf: '',
      // 是否需要公共头
      noHeader: false,
      powerList:[]
    }
  },
  created () {
    document.querySelector('body').setAttribute('style', 'padding:0!important')
    this.noHeader = this.$route.query.noHeader
    console.log(this.noHeader);
    document.title = '奥沙利文火星卡'
    this.statistics = this.$CONFIG.statistics
    this.isShare = this.getcommit('isShare')
    this.getToken()
    this.getStarInfo()
    this.shareInfo()
  },
  methods: {
    // 获取url上的信息
    getcommit (name) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            location.href
          ) || ["", ""])[1].replace(/\+/g, "%20")
        ) || false
      );
    },
    getcommit2 (url,name) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            url
          ) || ["", ""])[1].replace(/\+/g, "%20")
        ) || false
      );
    },
    // 获取token
    getToken () {
      if (this.$CONFIG.isVerify && this.isIOS) {
        this.token = '2a9cc326033c71cd67ac7caba01c2cd0*8028670'
      } else {
        this.token = this.getcommit('token') || ''
      }
      console.log(this.token);
    },
    // 获取奥沙利文会员卡信息
    async getStarInfo () {
      let params = {
        token: this.token,
        statistics: this.$CONFIG.statistics,
        pt: this.$route.query.pt,
        pf: this.$route.query.pf
      }
      let res = await this.$vipapi.getFansDetail(params)
      console.log(res);
      document.title = res.data.data.vipName
      this.pageTitle = res.data.data.vipName
      this.changeAppTitle(this.pageTitle)
      this.time = res.data.data.vipExpireTime
      this.timestampToTime(this.time)
      this.goodslist = res.data.data.goodsList
      this.desc = res.data.data.vipDesc
      this.powerList = res.data.data.privilege.info
    },
    // 跳转
    handleClick (toUrl) {
      console.log(toUrl);
      // this.isShare=0
      if (this.isShare == 1) {
        let reg = /\/appshop\//
        toUrl = toUrl.replace(reg, '/shareshop/')
        console.log(toUrl)
        window.open(toUrl)
      } else {
        var androidParam = '{"url":"' + toUrl + '"}'
        // var iosurl = toUrl.split('?')[0]
        var id = this.getcommit2(toUrl,'id')
        var istitle = this.getcommit2(toUrl,'istitle')
        var iosurl = toUrl.split('?')[0]
        var iosParam = {
          "url": iosurl+'?id='+id+'&istitle='+istitle
        }
        console.log(iosParam)
        try {
          window.webkit.messageHandlers.jumpWeb.postMessage(iosParam)
          // alert(iosParam)
        } catch (e) {
          console.log(0)
        }
        try {
          window.LiveAppJS.jumpWeb(androidParam)
          // alert(androidParam)
        } catch (e) {
          console.log(1)
        }
      }

    },
    // 处理时间
    timestampToTime (time) {
      var nowDate = new Date().getTime()
      var date = new Date(time * 1000) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      if (nowDate > date) {
        //过期了
        this.time = 0
      } else {
        var Y = date.getFullYear()
        var M = (date.getMonth() + 1 < 10 ? (date.getMonth() + 1) : date.getMonth() + 1)
        var D = date.getDate()
        this.year = Y
        this.month = M
        this.day = D
      }

    },
    // 没有公共头时的分享
    shareInfo () {
      // let host = window.location.hostname;
      // let jumpUrl = "https://" + host + "/sparta/#/start?share=1";
      // let jumpUrl = location.href;
      let jumpUrl = `https://${this.convertDomain('static.zhibo.tv')}/h5vip/vipstar/?isShare=1&noHeader=1`
      let imageUrl = "https://images.zhibo.tv/2020/0909/cardimg.png",
        title = "购买奥沙利文官方授权【火星卡】，可获赠超值大礼包，先到先得哦~",
        desc = "购买即可获赠奥沙利文官方授权签名款T恤、线上连线机会等权益";
      let param = {
        title: title,
        des: desc,
        imageUrl: imageUrl,
        jumpUrl: jumpUrl
      };
      console.log(title, imageUrl, jumpUrl, param)
      try {
        window.webkit.messageHandlers.shareProduct.postMessage(param);
      } catch (e) {
        console.log("ios启用分享按钮");
      }
      try {
        window.LiveAppJS.shareProduct(title, desc, imageUrl, jumpUrl);
      } catch (e) {
        console.log("Android启用分享按钮");
      }
    },
    // 判断环境
    convertDomain (currDomain) {
      var localDomain = window.location.host
      var name = localDomain.split('.', 2)[0]
      var arr = name.split('-', 2)
      return arr.length > 1 ? arr[0] + '-' + currDomain : currDomain
    },
    // 修改两端标题
    changeAppTitle (newtitle) {
      try {
        window.webkit.messageHandlers.changeTitle.postMessage(newtitle)
      } catch (e) {
        console.log('IOS修改标题',newtitle)
      }
      try {
        window.LiveAppJS.changeTitle(newtitle)
      } catch (e) {
        console.log("安卓修改标题",newtitle)
      }
    }
  },
}
</script>
<style lang='less' scoped>
/deep/ body{
  padding: 0 !important;
  background: #222224;
}
.m750 {
  margin: 0 auto;
  width: 100%;
  max-width: 750px;
  box-sizing: border-box;
  background: rgba(34, 34, 36, 1);
  position: relative;
  min-height: 100%;
}

.title_img {
  width: 1.84rem;
  height: 0.65rem;
  display: block;
}
.top {
  width: 100%;
  height: 3.91rem;
  padding-top: 0.2rem;
  position: relative;
}
.top_main {
  width: 100%;
  height: 3.91rem;
  background-image: url(https://images.zhibo.tv/2020/0723/top.png);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  position: relative;
}
.top .times {
  height: 0.33rem;
  font-size: 0.22rem;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: rgba(245, 211, 166, 1);
  line-height: 0.33rem;
  position: absolute;
  bottom: 0.05rem;
  left: 0;
  width: 70%;
  text-align: center;
}
.top .tips {
  height: 0.33rem;
  font-size: 0.34rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(245, 211, 166, 1);
  position: absolute;
  bottom: 0.6rem;
  left: 0;
  width: 71%;
  text-align: center;
  line-height: 0.34rem;
}
.title {
  width: 100%;
  margin: 0.1rem auto 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.title_left {
  display: block;
  width: 1.44rem;
  height: 0.04rem;
  background: linear-gradient(
    270deg,
    rgba(136, 114, 94, 1) 0%,
    rgba(228, 197, 168, 0) 100%
  );
}
.title_right {
  display: block;
  width: 1.44rem;
  height: 0.04rem;
  background: linear-gradient(
    -270deg,
    rgba(136, 114, 94, 1) 0%,
    rgba(180, 151, 123, 0) 100%
  );
}
.title h3 {
  height: 0.65rem;
  font-size: 0.46rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(196, 164, 133, 1);
  line-height: 0.65rem;
  background: linear-gradient(
    124deg,
    rgba(253, 240, 222, 1) 0%,
    rgba(248, 225, 191, 1) 25%,
    rgba(245, 211, 165, 1) 54%,
    rgba(245, 194, 149, 1) 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  padding: 0 0.29rem;
}
.sort1 {
  width: 100%;
  margin-top: 0.7rem;
}
.sort1_main {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0 0.3rem;
  box-sizing: border-box;
}
.goods:nth-of-type(2n-1) {
  margin-right: 0.2rem;
}
.goods .goods_img {
  width: 3.35rem;
  height: 3.35rem;
  /* background:#fff; */
  display: block;
  margin: 0.2rem 0;
  border-radius: 0.1rem;
  /* padding: .37rem .36rem .36rem .37rem; */
  box-sizing: border-box;
}
.goods .goods_img .img {
  width: 100%;
  height: 100%;
  display: block;
  border-radius: 0.1rem;
}
.goods a {
  width: 3.35rem;
  height: 4.19rem;
  display: block;
}
.goods .goods_news {
  width: 3.35rem;
  height: 0.64rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  line-height: 0.64rem;
  position: relative;
  background-image: url(https://images.zhibo.tv/2020/0723/price_bg.png);
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}
.goods_news .price {
  font-size: 0.18rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(250, 222, 185, 1);
  width: 56%;
  box-sizing: border-box;
  text-align: center;
}

.goods_news .price .money {
  font-size: 0.34rem !important;
  /* margin-left: -.07rem; */
}
.goods_news .buy {
  font-size: 0.26rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(34, 34, 36, 1);
  width: 44%;
  display: block;
  text-align: center;
}
.buy a {
  color: rgba(34, 34, 36, 1);
}
.sort2 {
  width: 100%;
  margin-top: 0.8rem;
}
.sort2_main {
  width: 6.9rem;
  background: rgba(39, 39, 41, 1);
  box-shadow: 0rem 0.02rem 0.12rem 0rem rgba(0, 0, 0, 0.12);
  border-radius: 0.1rem;
  margin: 0.2rem auto 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding-bottom: 0.5rem;
}

.sort3 {
  width: 100%;
  margin-top: 0.7rem;
}
.sort3_main {
  width: 6.9rem;
  background: rgba(39, 39, 41, 1);
  box-shadow: 0rem 0.02rem 0.12rem 0rem rgba(0, 0, 0, 0.12);
  border-radius: 0.1rem;
  margin: 0.2rem auto 0;
  display: flex;
  flex-direction: row;
}
.sort3_main .crown {
  width: 0.64rem;
  height: 0.52rem;
  display: block;
  /* margin: .27rem .16rem .15rem .18rem; */
  margin: auto 0.2rem;
}
.sort3_main p {
  font-size: 0.3rem;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 400;
  color: rgba(250, 222, 185, 1);
  line-height: 0.95rem;
  text-shadow: 0rem 0.01rem 0.01rem rgba(0, 0, 0, 0.5);
}
.sort4 {
  width: 100%;
  margin-top: 0.6rem;
}
.sort4_main {
  width: 6.9rem;
  background: rgba(39, 39, 41, 1);
  box-shadow: 0rem 0.02rem 0.12rem 0rem rgba(0, 0, 0, 0.12);
  border-radius: 0.1rem;
  margin: 0.2rem auto 0;
  padding: 0.4rem;
  box-sizing: border-box;
}
.sort4_main p {
  display: block;
  box-sizing: border-box;
  font-size: 0.26rem;
  font-family: PingFang-SC-Regular, PingFang-SC;
  font-weight: 400;
  color: rgba(250, 222, 185, 1);
  line-height: 0.45rem;
  text-shadow: 0rem 0.01rem 0.01rem rgba(0, 0, 0, 0.5);
}
.sort4_main li {
  display: block;
  padding-bottom: 0.5rem;
  box-sizing: border-box;
  font-size: 0.26rem;
  font-family: PingFang-SC-Regular, PingFang-SC;
  font-weight: 400;
  color: rgba(250, 222, 185, 1);
  line-height: 0.39rem;
  text-shadow: 0rem 0.01rem 0.01rem rgba(0, 0, 0, 0.5);
}
.sort4_main li:last-of-type {
  padding-bottom: 0 !important;
}
.bottom {
  height: 0.33rem;
  font-size: 0.24rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(238, 203, 154, 1);
  line-height: 0.33rem;
  letter-spacing: 0.04rem;
  text-align: center;
  padding-bottom: 1.06rem;
  padding-top: 0.7rem;
  background-color: rgba(34, 34, 36, 1);
  background-image: url(https://images.zhibo.tv/2020/0723/bottom_bg.png);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
</style>
